import request from "./request";

const AssessmentMasterService = {
    GetAll: async (context, signal) => {
        return await request.sendRequest(`/assessmentmaster/all/assessments`, context.token, signal);
    },
    Get: async (id, context, signal) => {
        return await request.sendRequest(`/assessmentmaster/assessment/${id}`, context.token, signal);
    },
    GetDashboard: async (context, signal) => {
        return await request.sendRequest(`/assessmentmaster/master/dashboard`, context.token, signal);
    },
    GetCourseWiseDashboard: async (context, signal) => {
        return await request.sendRequest(`/assessmentmaster/master/dashboard/courses`, context.token, signal);
    },
    GetCalender: async (context, startDate, endDate, signal) => {
        return await request.sendRequest(`/assessmentmaster/master/dashboard/calendar/${startDate}/${endDate}`, context.token, signal);
    },
    GetTypes: async (id, context, signal) => {
        return await request.sendRequest(`/assessmentmaster/types/${id}`, context.token, signal);
    },
    GetAttendees: async (id, searchText, context, signal) => {
        return await request.sendRequest(`/assessmentmaster/mcq/attendees/-1/0/${id}/${searchText}`, context.token, signal);
    },
    GetPracticalAttendees: async (id, searchText, context, signal) => {
        return await request.sendRequest(
            `/assessmentmaster/practical/attendees/-1/0/${id}/${searchText}`,
            context.token, signal
        );
    },
    GetSessions: async (id, searchText, context, signal) => {
        return await request.sendRequest(`/assessmentmaster/mcq/sessions/${id}/${searchText}`, context.token, signal);
    },
    GetPracticalSessions: async (id, searchText, context, signal) => {
        return await request.sendRequest(`/assessmentmaster/practical/sessions/${id}/${searchText}`, context.token, signal);
    },
    ImportMCQ: async (id, payload, context, signal) => {
        return await request.sendFormDataRequest(`/mcq/import/${id}`, payload, context, signal);
    },
    Save: async (payload, context, signal) => {
        return await request.sendPostRequest(`/assessmentmaster`, payload, context, signal);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/assessmentmaster/${id}`, context.token);
    },
};

export default AssessmentMasterService;
